import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import {
  ASSET_TAB_ASSETS,
  ASSET_TAB_INSURANCE,
  ASSET_TAB_VENDORS,
  ASSET_TAB_RENTAL_LEASES,
  ASSET_TAB_RENT_LEDGER,
  buildAssetManagementPath,
} from "../shared/utils/assetManagementTabs";
import TabsList from "./TabsList";

/**
 * Section tabs on Asset Management: Assets, Insurance, Vendors, and rental sections.
 */
function AssetManagementSectionTabs({ activeTab }) {
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  const showAssets = hasPermission && hasPermission("menu.asset_management");
  const showInsurance = hasPermission && hasPermission("menu.insurance_management");
  const showVendors = hasPermission && hasPermission("menu.vendor");
  const showLeases = hasPermission && hasPermission("menu.rental_leases");
  const showLedger = hasPermission && hasPermission("menu.rent_ledger");

  function go(tab) {
    if (activeTab === tab) return;
    navigate(buildAssetManagementPath({ tab }));
  }

  return (
    <TabsList className="section-tabs-list" role="tablist" aria-label="Asset Management sections">
      {showAssets ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === ASSET_TAB_ASSETS}
          className={`tab-btn ${activeTab === ASSET_TAB_ASSETS ? "active" : ""}`}
          onClick={() => go(ASSET_TAB_ASSETS)}
        >
          Assets
        </button>
      ) : null}
      {showInsurance ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === ASSET_TAB_INSURANCE}
          className={`tab-btn ${activeTab === ASSET_TAB_INSURANCE ? "active" : ""}`}
          onClick={() => go(ASSET_TAB_INSURANCE)}
        >
          Insurance
        </button>
      ) : null}
      {showVendors ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === ASSET_TAB_VENDORS}
          className={`tab-btn ${activeTab === ASSET_TAB_VENDORS ? "active" : ""}`}
          onClick={() => go(ASSET_TAB_VENDORS)}
        >
          Vendors
        </button>
      ) : null}
      {showLeases ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === ASSET_TAB_RENTAL_LEASES}
          className={`tab-btn ${activeTab === ASSET_TAB_RENTAL_LEASES ? "active" : ""}`}
          onClick={() => go(ASSET_TAB_RENTAL_LEASES)}
        >
          Rental Leases
        </button>
      ) : null}
      {showLedger ? (
        <button
          type="button"
          role="tab"
          aria-selected={activeTab === ASSET_TAB_RENT_LEDGER}
          className={`tab-btn ${activeTab === ASSET_TAB_RENT_LEDGER ? "active" : ""}`}
          onClick={() => go(ASSET_TAB_RENT_LEDGER)}
        >
          Rent Ledger
        </button>
      ) : null}
    </TabsList>
  );
}

export default AssetManagementSectionTabs;
